import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { CreateAccountUserCommand } from '../../../../commands/accounts/create.account.command';
import { ButtonTriggerEvent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import {
    ConfirmModalActions,
    ConfirmModalData
} from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { ModalService } from '../../../../common/services/modal.service';
import { AccountUser } from '../../../../models/admin/account';
import { AccountApiService } from '../../../../services/account.api.service';
import { AlertifyService } from '../../../../services/alertify.service';
import { AccountUsersModalData } from './account.users.modal.provider';

@Component({
    templateUrl: './account.users.modal.component.html',
    styleUrls: ['./account.users.modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountUsersModalComponent extends BaseComponent {

    public accountUsers: AccountUser[];
    public hubName: string;
    public createAccountUserCommand = new CreateAccountUserCommand('','', '');
    public createAccountFormGroup: FormGroup;


    constructor(private fb: FormBuilder,
                private alertify: AlertifyService,
                private modalService: ModalService,
                private accountApiService: AccountApiService,
                private dialogRef: MatDialogRef<AccountUsersModalComponent>,
                data: AccountUsersModalData) {
        super();
        this.hubName = data.hubName;
        this.createAccountUserCommand.hubName = this.hubName;
    }

    ngOnInit() {
        this.createAccountFormGroup = this.fb.group({
            'userName': [null, [Validators.required]],
            'password': [null, [Validators.required]]
        });

        this.fetchAccountUsers();
    }

    close() {
        this.dialogRef.close();
    }

    public createUser(event: ButtonTriggerEvent) {
        this.accountApiService.createAccountUsers(this.hubName, this.createAccountUserCommand).finally(event.complete).subscribe(x => {
            if (x && x.success) {
                this.alertify.successfully('User created');
                this.fetchAccountUsers();
            }
            if (x && !x.success) {
                this.alertify.warning(x.msg);
            }
        });
    }

    public deleteUser(user: AccountUser) {
        let actions = <ConfirmModalActions>{
            confirm: (event: ButtonTriggerEvent) => {
                this.accountApiService.deleteAccountUser(this.hubName, user.userName)
                    .finally(event.complete)
                    .subscribe(() => {
                        this.alertify.successfully('User deleted');
                        this.fetchAccountUsers();
                    });
            }
        };

        let data = <ConfirmModalData>{
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to delete this user?',
            confirmModalConfirmButtonText: 'Delete',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true
        };

        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                {provide: ConfirmModalActions, useValue: actions},
                {provide: ConfirmModalData, useValue: data}
            ]
        });
    }

    private fetchAccountUsers() {
        this.accountApiService.getAccountUsers(this.hubName)
            .subscribe(accounts =>
                {
                    accounts.forEach(x => x.createLocalString = new Date(x.created).toLocaleString());
                    this.accountUsers = accounts;
                }
            );
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/account.users/account.users.modal.component.ts